import styled from 'styled-components';

import { CARD_BORDER } from './base';

// ---------------------------------------------------------------------------
// Régua de Cobrança — visão "Linha do tempo" (adendo 01): faixa de baldes,
// gráfico divergente e notas. Rótulos do gráfico são HTML absolutamente
// posicionado sobre o SVG (nunca <text>) — a posição percentual vem do
// componente via style inline, aqui fica só a tipografia.
// ---------------------------------------------------------------------------

export const BucketRow = styled.div`
   padding: 14px 16px;
   display: flex;
   gap: 10px;
   align-items: stretch;
   flex-wrap: wrap;
`;

// Card de balde. $tone: 'today' (destaque azul) | 'alert' (tracejado
// vermelho do "Sem compromisso") | default branco.
export const BucketCard = styled.div`
   flex: 1;
   min-width: 132px;
   border-radius: 12px;
   padding: 11px 12px;
   display: flex;
   flex-direction: column;
   gap: 3px;
   border: ${({ $tone }) => {
      if ($tone === 'today') return '1px solid rgba(64, 152, 239, 0.45)';
      if ($tone === 'alert') return '1px dashed rgba(220, 38, 38, 0.45)';
      return `1px solid ${CARD_BORDER}`;
   }};
   background: ${({ $tone }) => {
      if ($tone === 'today') return 'rgba(64, 152, 239, 0.06)';
      if ($tone === 'alert') return 'rgba(220, 38, 38, 0.05)';
      return '#fff';
   }};
`;

export const BucketLabel = styled.div`
   display: flex;
   align-items: center;
   gap: 7px;
   font-size: 11px;
   font-weight: 800;
   color: ${({ $alert }) => ($alert ? '#a01b1b' : '#666')};

   svg {
      flex-shrink: 0;
   }
`;

export const BucketDot = styled.span`
   width: 8px;
   height: 8px;
   border-radius: 2px;
   flex: 0 0 8px;
   background: ${({ $color }) => $color ?? '#8a8a8a'};
`;

export const BucketValueRow = styled.div`
   display: flex;
   align-items: baseline;
   gap: 5px;
`;

export const BucketValue = styled.span`
   font-size: 22px;
   font-weight: 800;
   font-variant-numeric: tabular-nums;
   color: ${({ $color }) => $color ?? '#111'};
`;

export const BucketUnit = styled.span`
   font-size: 11px;
   color: #9a9a9a;
`;

export const BucketSub = styled.div`
   font-size: 11px;
   color: #8a8a8a;
`;

// ─── Gráfico ──────────────────────────────────────────────────────────────

export const ChartPad = styled.div`
   padding: 0 16px 8px;
`;

export const ChartWrap = styled.div`
   position: relative;
   width: 100%;

   svg {
      width: 100%;
      height: auto;
      display: block;
   }
`;

// Pill "Hoje" acima da área de plot; `left` percentual vem do componente.
export const TodayPill = styled.div`
   position: absolute;
   top: 2%;
   transform: translateX(-50%);
   font-size: 10px;
   font-weight: 800;
   padding: 3px 9px;
   border-radius: 999px;
   background: ${({ theme }) => theme?.colors?.primary ?? '#4098ef'};
   color: #fff;
   white-space: nowrap;
`;

export const AxisYLabel = styled.div`
   position: absolute;
   left: 3.4%;
   transform: translate(-100%, -50%);
   font-size: 11px;
   color: #9a9a9a;
   font-variant-numeric: tabular-nums;
`;

export const AxisXLabel = styled.div`
   position: absolute;
   top: 84%;
   transform: translateX(-50%);
   font-size: 11px;
   font-weight: ${({ $today }) => ($today ? 800 : 600)};
   color: ${({ $today }) => ($today ? '#0b3a63' : '#9a9a9a')};
   white-space: nowrap;
`;

// Camada de hover: 29 células transparentes sobre a área de plot.
export const HoverLayer = styled.div`
   position: absolute;
   left: 2.3%;
   top: 9.2%;
   width: 97.4%;
   height: 71.5%;
   display: flex;
`;

export const HoverCell = styled.div`
   flex: 1;
   min-width: 0;
   height: 100%;
   cursor: ${({ $hasValue }) => ($hasValue ? 'help' : 'default')};
`;

// ─── Rodapé e notas ───────────────────────────────────────────────────────

export const ChartFootnote = styled.div`
   padding: 4px 16px 12px;
   font-size: 11px;
   color: #9a9a9a;
   line-height: 1.5;
`;

export const ClosedNote = styled.div`
   margin: 0 16px 12px;
   padding: 10px 12px;
   border-radius: 10px;
   background: #f7f7f8;
   border: 1px solid rgba(0, 0, 0, 0.07);
   font-size: 12px;
   color: #666;
   display: flex;
   gap: 8px;
   align-items: center;

   svg {
      flex-shrink: 0;
      color: #8a8a8a;
   }
`;

export const TimelineEmpty = styled.div`
   padding: 44px 16px;
   text-align: center;
   border-bottom: 1px solid rgba(0, 0, 0, 0.07);
`;
